<template>
  <f7-page name="config-voltage-alarms" ref="page">
    <f7-navbar :sliding="false">
      <f7-nav-left back-link="Back">
      </f7-nav-left>
      <f7-nav-title sliding>{{ $t('ConfigVoltageAlarms') }}</f7-nav-title>
      <f7-nav-right>
        <label :for="inputSubmitId" v-if="isLowPowerShowed || isPowerDisconnectShowed || isIgnitionOnShowed" class="link icon-only">
          <i class="icon f7-icons">checkmark_alt</i>
        </label>
      </f7-nav-right>
    </f7-navbar>
    <f7-progressbar v-if="isLoading || isLoadingSSP || isLoadingAssetData" infinite color="green" class="progressbar-top"></f7-progressbar>

    <f7-block v-if="isLowPowerShowed || isPowerDisconnectShowed || isIgnitionOnShowed">
      <p class="text-color-red" v-html="$t('PowerSettingsDescription', {
          lowBattery: DefaultLowBattery,
          batteryDisconnect: DefaultBatteryDisconnect,
          ignitonOn: DefaultIgnitionOn})"></p>
    </f7-block>

    <f7-block v-if="!isLoadingSSP && !isLoadingAssetData && !isLowPowerShowed && !isPowerDisconnectShowed && !isIgnitionOnShowed">
      <p>{{ $t('NoPowerSettings') }}</p>
    </f7-block>

    <f7-list v-if="isLoadingSSP || isLoadingAssetData" class="skeleton-text skeleton-effect-wave" key="assetLoadSkeleton">
      <f7-list-item
          v-for="n in 4"
          :key="n"
          header="Header"
          title="Title"
      >
        <template #media>
          <f7-skeleton-block
              style="width: 40px; height: 40px; border-radius: 50%"
          ></f7-skeleton-block>
        </template>
      </f7-list-item>
    </f7-list>

    <form v-else action="" @submit.prevent="onSubmit">
      <input type="submit" :id="inputSubmitId" hidden >

      <f7-block-title>{{$t('AssetDetails')}}</f7-block-title>
      <f7-list>
        <f7-list-item :title="TargetAsset.IMEI" :header="$t('IMEI')">
          <template #media>
            <f7-icon icon="f7-icons text-color-lightgray icon-number"></f7-icon>
          </template>
        </f7-list-item>
        <f7-list-item :title="TargetAsset.SimNO" :header="$t('IMSI')">
          <template #media>
            <f7-icon icon="f7-icons text-color-lightgray icon-other-imei"></f7-icon>
          </template>
        </f7-list-item>
        <f7-list-item :title="TargetAsset.Product" :header="$t('DeviceType')">
          <template #media>
            <f7-icon icon="f7-icons text-color-lightgray "></f7-icon>
          </template>
        </f7-list-item>
        <f7-list-item :title="TargetAsset.Solution" :header="$t('SolutionType')">
          <template #media>
            <f7-icon :icon="`f7-icons text-color-lightgray ${solutionTypeIcon}`"></f7-icon>
          </template>
        </f7-list-item>
      </f7-list>



      <f7-block-title v-if="isLowPowerShowed || isPowerDisconnectShowed || isIgnitionOnShowed"
                      class="display-flex justify-content-space-between align-items-flex-end">
        <div>{{ $t('PowerSettings') }}</div>
        <div>
          <f7-button fill raised small color="green" @click="setDefaultValues">{{ $t('SetDefault') }}</f7-button>
        </div>
      </f7-block-title>
      <f7-list v-if="isLowPowerShowed || isPowerDisconnectShowed || isIgnitionOnShowed" class="no-hairline-bottom">
        <f7-list-input
            v-if="isLowPowerShowed"
            type="tel"
            :label="$t('LowBattery')"
            :placeholder="$t('LowBattery')"
            required
            validate
            pattern="[0-9]*"
            :error-message="$t('OnlyNumbers')"
            v-model:value="LowBattery"
        >
          <template #media>
            <f7-icon icon="f7-icons text-color-lightgray"></f7-icon>
          </template>
        </f7-list-input>
        <f7-list-input
            v-if="isPowerDisconnectShowed"
            type="tel"
            :label="$t('BatteryDisconnect')"
            :placeholder="$t('BatteryDisconnect')"
            required
            validate
            pattern="[0-9]*"
            :error-message="$t('OnlyNumbers')"
            v-model:value="BatteryDisconnect"
        >
          <template #media>
            <f7-icon icon="f7-icons text-color-lightgray"></f7-icon>
          </template>
        </f7-list-input>
        <f7-list-input
            v-if="isIgnitionOnShowed"
            type="tel"
            :label="$t('IgnitionOn')"
            :placeholder="$t('IgnitionOn')"
            required
            validate
            pattern="[0-9]*"
            :error-message="$t('OnlyNumbers')"
            v-model:value="IgnitionOn"
        >
          <template #media>
            <f7-icon icon="f7-icons text-color-lightgray"></f7-icon>
          </template>
        </f7-list-input>
      </f7-list>
    </form>
  </f7-page>
</template>

<script>
import {f7} from "framework7-vue";
import {mapGetters} from "vuex";
import {QTAPI} from "../../../services/qt-api";
import {getSolutionTypeIcon, ProductFeaturesEnum} from "../../../js/helpers";

export default {
  name: "config-voltage-alarms",

  data(){
    return{
      inputSubmitId: f7.utils.id(),

      isLoading: false,
      isLoadingSSP: false,
      isLoadingAssetData: false,

      ProductList: [],
      SolutionTypeList: [],
      ProductCode: null,
      SolutionCode: null,
      LowBattery: null,
      BatteryDisconnect: null,
      IgnitionOn: null,

      DefaultLowBattery: 1150,
      DefaultBatteryDisconnect: 600,
      DefaultIgnitionOn: 1350,
    }
  },

  computed: {
    ...mapGetters(['MajorToken', 'MinorToken', 'TargetAsset']),

    isLowPowerShowed(){
      let ret = false
      if(!this.ProductCode && !this.ProductList.length){
        return ret
      }

      let productObg = this.ProductList.find( (item) => item.Code === this.ProductCode )
      if(!productObg){
        return ret
      }

      let solutionObj = this.SolutionTypeList.find( (item) => item.Code === this.SolutionCode )
      if(!solutionObj){
        return ret
      }

      return (parseInt(productObg.Features) & ProductFeaturesEnum.Power) > 0 &&
          solutionObj.Features && solutionObj.Features.indexOf("LOWER_POWER,") >= 0
    },
    isPowerDisconnectShowed(){
      let ret = false
      if(!this.ProductCode && !this.ProductList.length){
        return ret
      }

      let productObg = this.ProductList.find( (item) => item.Code === this.ProductCode )
      if(!productObg){
        return ret
      }

      let solutionObj = this.SolutionTypeList.find( (item) => item.Code === this.SolutionCode )
      if(!solutionObj){
        return ret
      }

      return (parseInt(productObg.Features) & ProductFeaturesEnum.Power) > 0 &&
          solutionObj.Features && solutionObj.Features.indexOf("DISCONNECT_POWER,") >= 0
    },
    isIgnitionOnShowed(){
      let ret = false
      if(!this.ProductCode && !this.ProductList.length){
        return ret
      }

      let productObg = this.ProductList.find( (item) => item.Code === this.ProductCode )
      if(!productObg){
        return ret
      }

      let solutionObj = this.SolutionTypeList.find( (item) => item.Code === this.SolutionCode )
      if(!solutionObj){
        return ret
      }

      return (parseInt(productObg.Features) & ProductFeaturesEnum.Power) > 0 &&
          solutionObj.Features && solutionObj.Features.indexOf("IGNITION_ON,") >= 0
    },
    solutionTypeIcon(){
      return getSolutionTypeIcon(this.TargetAsset.Solution)
    }
  },

  mounted() {
    this.getSSP();
    this.getAssetInfo();
  },

  methods: {
    async onSubmit(){
      this.isLoading = true;
      let result = await QTAPI.SetPowerLevels({
        MinorToken: this.MajorToken,

        IMEI: this.TargetAsset.IMEI,

        LowerPower: this.LowBattery ? +this.LowBattery / 100 : 0,
        DisconnectPower: this.BatteryDisconnect ? +this.BatteryDisconnect / 100 : 0,
        IgnitionPower: this.IgnitionOn ? +this.IgnitionOn / 100 : 0,

        MobileToken: localStorage.PUSH_MOBILE_TOKEN,
        AppKey: localStorage.PUSH_APP_KEY,
        Token: localStorage.PUSH_DEVICE_TOKEN,
        Type: localStorage.DEVICE_TYPE,
      })
      this.isLoading = false;
      if(!result){
        return
      }
      f7.notification.create({
        subtitle: this.$t('Success'),
        text: this.$t('DataUpdated'),
      }).open()
      f7.views.main.router.back()
    },

    async getSSP(){
      this.isLoadingSSP = true;
      let ssp = await QTAPI.GetSSP({ DealerToken: this.MajorToken })
      this.isLoadingSSP = false;
      if(!ssp){
        return
      }
      this.ProductList = ssp.Products
      this.SolutionTypeList = ssp.Solutions
    },
    async getAssetInfo(){
      this.isLoadingAssetData = true
      let result = await QTAPI.GetAssetInfo({majortoken: this.MajorToken, imeis: this.TargetAsset.IMEI})
      this.isLoadingAssetData = false
      if(!result){
        return
      }

      this.ProductCode = result.ProductCode
      this.SolutionCode = result.Solution
      this.IgnitionOn = result.PowerOn
      this.LowBattery = result.LowPower
      this.BatteryDisconnect = result.DisconnectPower

      /*this.Input1Name = result.Input1Name
      this.Input1Mask = result.Input1Mask
      this.Input1Type = result.Input1Type
      this.Input2Name = result.Input2Name
      this.Input2Mask = result.Input2Mask
      this.Input2Type = result.Input2Type*/

    },
    setDefaultValues(){
      this.LowBattery = this.DefaultLowBattery
      this.BatteryDisconnect = this.DefaultBatteryDisconnect
      this.IgnitionOn = this.DefaultIgnitionOn
    }
  }
}
</script>

<style scoped>

</style>